import React from 'react'
import { useField, useFormikContext } from 'formik'
import Icon from 'components/Icon/Icon'
import { ExtraBlockContainer } from './styles'
import Field from 'components/Shared/Fields'
import Text from 'particles/Text'
import { useNewTranslation } from 'hooks'
import RectangleButton from 'particles/Button/RectangleButton'
import { generateUuid } from 'services/uuid'
import { fieldIdentifiers } from 'components/Shared/Comment'
interface ExtraTextEditorProps {
    name: string
    buttonText?: string
    isRequired?: boolean
    isReadOnly?: boolean
}
enum EXTRA_TEXT_VALUES {
    TITLE = 'title',
    DESCRIPTION = 'description',
}
const ExtraTextEditor: React.FC<ExtraTextEditorProps> = ({
    name,
    isRequired = false,
    buttonText,
    isReadOnly = false,
}) => {
    const [t] = useNewTranslation()
    const [field, meta] = useField<{ title: string; description: string; uuid: string }[]>(name)
    const { setFieldValue } = useFormikContext()
    const fieldValue = field.value || []
    const hasError = Boolean(meta.error)

    const addItem = (e: any): void => {
        e.preventDefault()
        const newValue = [...fieldValue, { title: '', description: '', uuid: generateUuid() }]
        setFieldValue(field.name as never, newValue)
    }

    const removeItem =
        (index: number) =>
        (e: any): void => {
            e.preventDefault()
            const items = [...fieldValue]
            items.splice(index, 1)
            setFieldValue(field.name as never, items)
        }
    return (
        <div className="extra-block">
            {fieldValue.map((value: { title: string; description: string; uuid: string }, index: number) => {
                const isShowError = !value[EXTRA_TEXT_VALUES.TITLE] || !value[EXTRA_TEXT_VALUES.DESCRIPTION]
                return (
                    <ExtraBlockContainer key={index}>
                        <div className="field-bigger-title">
                            <Text scale="bodyM700" color="primary">
                                {t('campaignEditor.createTask.addTextFieldHeader')}
                            </Text>
                            {!isReadOnly && <Icon.CloseIcon onClick={removeItem(index)} />}
                        </div>
                        <Field.TextInputField
                            label={t('campaignEditor.createTask.enterTitleHeader')}
                            name={`${name}[${index}].title`}
                            isRequired={isRequired}
                            width="100%"
                            isError={!value[EXTRA_TEXT_VALUES.TITLE] && hasError}
                            isReadOnly={isReadOnly}
                            identifier={`${value.uuid}_${fieldIdentifiers.additionTitle}`}
                        />
                        <Field.TextAreaField
                            label={t('campaignEditor.createTask.enterDescriptionHeader')}
                            name={`${name}[${index}].description`}
                            isRequired={isRequired}
                            width="100%"
                            isError={!value[EXTRA_TEXT_VALUES.DESCRIPTION] && hasError}
                            isReadOnly={isReadOnly}
                            identifier={`${value.uuid}_${fieldIdentifiers.additionDescription}`}
                        />
                        <div className="error">{hasError && isShowError && meta.error}</div>
                    </ExtraBlockContainer>
                )
            })}
            {!isReadOnly && (
                <RectangleButton
                    form="outlined"
                    size="s"
                    label={buttonText ? buttonText : t('button.addTextField')}
                    onClick={addItem}
                    icon="plus"
                />
            )}
        </div>
    )
}

export default ExtraTextEditor
